
import { createAction } from '@reduxjs/toolkit'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { getProductById } from 'services/product'
import { PPProduct } from 'shared'
import { StoreThunkAction, StoreThunkDispatch } from 'store/state'
import { V1 } from './net'

export const startImpersonation = createAction<{ user: any, productInfo: PPProduct | undefined }>('admin/impersonate/start')
export const ACTION_IMPERSONATE_STOP = 'ACTION_IMPERSONATE_STOP'

export function impersonateUser(user: any) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.impersonate(user.userId)).subscribe(() => {
      const productId = user.product.replace(/-annual|-monthly|-lifetime/g, '')
      const productInfo = dispatch(getProductById(productId))

      dispatch(startImpersonation({ user, productInfo }))
    })
  }
}

export function stopImpersonateUser() {
  return {
    type: ACTION_IMPERSONATE_STOP
  }
}

export function searchUsers(query: string): StoreThunkAction<Observable<any>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.searchUsers(query.trim())).pipe(map(response => {
      if (response.error) {
        throw (new Error('An error occured: ' + response.error))
      }

      return response.data
    }))
  }
}
